import React from "react";

const GradeScale = (props) => {
  const { grade, formValues, seasonGrades } = props;
  let gradeInt = parseInt(grade);

  const containerStyles = {
    height: 30,
    width: "100%",
    backgroundColor: "#e0e0de",
    borderRadius: 30,
  };

  const fillerStyles = {
    zIndex: "auto",
    height: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    borderRadius: 30,
    width: `${grade}%`,
    backgroundImage: "linear-gradient(to right, #512889, #ED872D)",
    textAlign: "right",
    transition: "width 2s ease-in-out",
  };

  const labelStyles = {
    zIndex: "auto",
    padding: 5,
    color: "white",
    fontWeight: "bold",
  };

  const svg = {
    width: "100%",
  };

  let letterGrade = "";

  if (grade >= 97) letterGrade = "A+";
  else if (grade <= 96.9 && grade >= 93) letterGrade = "A";
  else if (grade <= 92.9 && grade >= 90) letterGrade = "A-";
  else if (grade <= 89.9 && grade >= 87) letterGrade = "B+";
  else if (grade <= 86.9 && grade >= 83) letterGrade = "B";
  else if (grade <= 82.9 && grade >= 80) letterGrade = "B-";
  else letterGrade = "C";

  return (
    <div className="Grade-Scale">
      <h2>Average Boost Score for {formValues.company}'s Greenhouse</h2>
      <div className="CompareExplain">
        This is your Boost Score averaged across four seasons.
      </div>
      <div className="LetterGrade">{letterGrade}</div>
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <span style={labelStyles}>{`${grade}%`}</span>
        </div>
      </div>
    </div>
  );
};

export default GradeScale;
